import { Button } from "@material-ui/core"
import React, { useState } from "react"

declare var window:any

export const ShareQrcodeTest = () => {
    const [qrCodeUrl] = useState("http://qrcode.meetheed.com/images/qr_code_url.png")

    const download = async () => {

        if (window.IdhaSharePlugin == undefined) {
            alert('plugin IdhaSharePlugin nao encontrado')
            return
        }

        const downloadImageAsync = async () => new Promise((resolve,reject) => window.IdhaSharePlugin.downloadImage(qrCodeUrl,resolve,reject))

        await downloadImageAsync()
    }

    const share = async () => {
        if (window.IdhaSharePlugin == undefined) {
            alert('plugin IdhaSharePlugin nao encontrado')
            return
        }

        const shareImageAsync = async () => new Promise((resolve,reject) => window.IdhaSharePlugin.shareImage(qrCodeUrl, resolve,reject))

        await shareImageAsync()
    }

    return <>
        <Button onClick={share} variant="contained" color="primary">
            Share
        </Button>
    </>
}